import React from "react";
import style from "./index.module.scss";
import { Badge, Icon } from "antd";
import className from "classnames";

import {
    closeSession,
    errorMessage,
    FormatTime,
    ResultMessage
} from "../../../../../../polyfills";
import { SimpleSessionItem } from "../../../../../../types";
import { curSessionIdAtom } from "../../../../../../store";
import { useSetAtom } from "jotai";
import useUpdateSession from "../../../../../../Utils/useUpdateSession";

interface ListItemProps {
    item: SimpleSessionItem; //当前项
    changeCurrentChat: () => void;
    active: boolean; //是否选中
}

export default function ListItem({
    item,
    changeCurrentChat,
    active
}: ListItemProps) {
    const sessionManager = useUpdateSession();
    const setCurSessionId = useSetAtom(curSessionIdAtom);

    //关闭会话
    const onClose = async () => {
        try {
            await closeSession(item.guid);
            setCurSessionId(undefined);
            sessionManager.removeSession(item.guid);
        } catch (e) {
            ResultMessage.error(errorMessage(e));
        }
    };

    return (
        <div
            className={className(style.root, { [style.active]: active })}
            onClick={changeCurrentChat}>
            <Badge dot={item.hasNewMessage}>
                <div className={style.info}>
                    <div className={style.name}>
                        {item.sessionTopic} （{item.userNo}）
                    </div>

                    <div className={style.time}>
                        {!!item.lastSessionTime &&
                            FormatTime(item.lastSessionTime)}
                    </div>
                </div>
                <div className={style.chats}>
                    {item.lastMsgContent || "暂无记录"}
                </div>
            </Badge>

            <Icon
                type="close-circle"
                theme="filled"
                className={style.close}
                onClick={onClose}
            />
        </div>
    );
}
